import React, { Component } from 'react'

export default class redArrow extends Component {
    render() {
        return (
            
<svg className={this.props.className} onClick={this.props.className} width="172" height="308" viewBox="0 0 172 308" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M77.1172 83.793C80.4272 119.303 98.0272 154.013 98.0272 154.013C98.0272 154.013 80.4272 188.723 77.1172 224.233C91.5472 194.043 134.187 173.833 134.187 154.013C134.187 134.193 91.5472 113.983 77.1172 83.793Z" fill="#FF544F"/>
<g style="mix-blend-mode:multiply" filter="url(#filter0_f)">
<path d="M44.3086 44.7852H47.2841L127.241 154.012L47.2841 263.239H44.3086V44.7852Z" fill="#BBC1DA"/>
</g>
<path d="M6.52734 8.27344H37.2402L109.316 139.577C114.251 148.568 114.252 159.458 109.316 168.449L37.2402 299.753H6.52734V8.27344Z" fill="white"/>
<defs>
<filter id="filter0_f" x="0.308594" y="0.785156" width="170.933" height="306.454" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="22" result="effect1_foregroundBlur"/>
</filter>
</defs>
</svg>

        )
    }
}
